import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviateNumber'
})
export class AbbreviateNumberPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    let output: string = `${value}`;

    if (value <= 1000000000) {
      output = "Less than $1 Billion";
    }
    else if (value <= 1000000000000){
      let numInBillions: number = value / 1000000000;
      output = `$${numInBillions.toFixed(2)} Billion`;
    }
    else {
      let numInTrillions: number = value / 1000000000000;
      output = `$${numInTrillions.toFixed(2)} Trillion`;
    }

    return output;
  }

  private numberWithCommas(num: number): string{
    let parts: string[] = num.toString().split(' ');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join(' ');
  }
}
